import { Component, HostListener, inject, signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BarLineChart, ChartData } from '../../../../_shared';
import { DateFilterComponent } from '../../../../../_shared/components';
import { DateIntervalFilterData } from '../../../../../_shared/models';
import { DateInterval } from '../../../../../_shared/enums';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-moving-time-big-modal',
  imports: [BarLineChart, DateFilterComponent, TranslocoDirective],
  standalone: true,
  templateUrl: './moving-time-big-modal.component.html',
  styleUrl: './moving-time-big-modal.component.scss'
})
export class MovingTimeBigModal {
  // Mock headline figures until the API supplies this summary.
  protected readonly headline = { value: '200ℓ', change: '+19.29%' };
  // protected idleMovingTimeData = ChartData.movingVsIdleTime;
  protected idleMovingTimeData = ChartData.movingVsIdleTimeBigData;
  protected chartMargin = { top: 10, right: 1, bottom: 37, left: 33, height: 293 };
  protected viewMode = signal<'all' | 'moving' | 'idle'>('all');
  private readonly modalRef = inject(NgbActiveModal);

  public utilizationDateFilter: DateIntervalFilterData;
  public defaultInterval: DateInterval = DateInterval.Day;

  constructor() {
    this.utilizationDateFilter = {} as DateIntervalFilterData;
  }

  onUtilizationDateFilterChange(filter: DateIntervalFilterData): void {
    this.utilizationDateFilter = filter;
  }

  protected buttonMenuClick(event: MouseEvent): void {
    event.stopPropagation();
  }

  protected closeModal(): void {
    this.modalRef.close();
  }
}
